export default __webpack_public_path__ + "static/media/logo-Setu-India.ae0d5e58.jpg";